module.exports = __webpack_public_path__ + "img/download.8e54a9f4.svg";